//File: src/main.jsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './index.css';
import { AuthProvider } from './contexts/AuthContext';
import { NetworkProvider } from './contexts/NetworkContext';
import { LayoutProvider } from './contexts/LayoutContext';
import { registerPWA } from './pwa';

// Check online status immediately before any initialization
if (!navigator.onLine) {
  document.body.innerHTML = `<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; text-align: center; padding: 20px; font-size: 1.2rem; gap: 20px;">
    <div>Sorry for the trouble, but you must be online to launch this application. Once you have opened the app, you can use it offline for 24 hours. You can move the app to the background, but just don't close it.</div>
    <button 
      onclick="window.close()" 
      style="
        background-color: rgb(59 130 246); 
        color: white; 
        padding: 8px 16px; 
        border-radius: 6px; 
        font-weight: 500;
        border: none;
        cursor: pointer;
        font-size: 1rem;
        transition: background-color 0.2s;
      "
      onmouseover="this.style.backgroundColor='rgb(29 78 216)'"
      onmouseout="this.style.backgroundColor='rgb(59 130 246)'"
    >
      Exit
    </button>
  </div>`;
} else {
  // Only initialize the app if we're online
  registerPWA();
  
  const rootElement = document.getElementById('root');
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <NetworkProvider>
            <LayoutProvider>
              <App />
            </LayoutProvider>
          </NetworkProvider>
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}
